// This interceptor is used to mask the phone numbers in the response

import { Injectable } from '@angular/core';
import { HttpInterceptor, HttpRequest, HttpHandler, HttpEvent, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { LocalStorageService } from '../services/localstorage.service';


@Injectable()
export class CallMaskingInterceptor implements HttpInterceptor {
  exemptedUrls: string[] = [];
  maskValueKeys: string[] = ['home', 'mobile', 'work', 'phone_number'];
  isCallMaskingEnabled: any;

  constructor(readonly localStorage: LocalStorageService) {}

  intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    // if url is backend then, process the response
    const companyPolicy = this.localStorage.getLocalStorage('company_policy');
    const dcApiUrl = this.localStorage.getLocalStorage('dc_api_url');
    const isMaskingEnabled = companyPolicy?.zuper_connect?.voice?.call_masking
    const isUserNotAdmin = this.localStorage.getLocalStorage('user')?.role?.role_key !== 'ADMIN';
    if (this.exemptedUrls.includes(req.url) || !isMaskingEnabled || !req.url.includes(dcApiUrl) || !isUserNotAdmin) {
      return next.handle(req);
    }else{
      return next.handle(req).pipe(
        map((event: HttpEvent<any>) => {
          if (event instanceof HttpResponse) {
            return event.clone({ body: {
                ...event.body,
                data: this.maskPhoneNumber(event.body.data)
              }
            });
          }
          return event;
        })
      );
    }
  }


  maskPhoneNumber(data: any, key?: string): any{
    if(this.isDataArray(data)){
      data.forEach((item: any) => {
        this.maskPhoneNumber(item);
      });
    }else if(this.isDataObject(data)){
      Object.keys(data).forEach(key => {
        data[key] = this.maskPhoneNumber(data[key], key);
      });
    }else if(this.isDataString(data)){
      if(this.maskValueKeys.includes(key)){
        data = data.replace(/\d/g, 'X');
      }
    }
    return data;
  }

  isDataArray(data: any): boolean{
    return Array.isArray(data);
  }

  isDataObject(data: any): boolean{
    return typeof data === 'object' && data !== null;
  }

  isDataString(data: any): boolean{
    return typeof data === 'string';
  }
}
